import { useState, useMemo } from "react";
import {
    Container,
    Typography,
    Box,
    Paper,
    Button,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    InputAdornment,
    Modal,
    Card,
    CardContent,
    Grid
} from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { DataGrid } from "@mui/x-data-grid";
import { TituloPrincipal, buttonGuardar, buttonCancelar, InputBuscador, Texto, Input, InputDescripcion, inputFechaGrande, modalStyle } from "../../Layouts/CustomStyles";
import Logocolor from "../../Image/Logo.png";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { DiseñoDataGrid } from "../../Components/FuncionesGenerales/DataGrid";
import { GiMoneyStack } from "react-icons/gi";
import { FaTrashCan } from "react-icons/fa6";
import { handleExportarExcel } from "../../Components/FuncionesGenerales/excel/ExcelCBOEgreso";
import { useGetSucursal } from "../../Services/Sucursales";


// ✅ Hooks personalizados
import { useEgresoCBO, useGetEgreso } from "../../Services/EgresoCBO";

export const EgresoCBO = () => {
    const { crearEgreso, editarEgreso, eliminarEgreso, } = useEgresoCBO();
    const { egresos, loadingEgresos, refetchEgresos } = useGetEgreso();
    const { sucursales } = useGetSucursal();
    const [openCrear, setOpenCrear] = useState(false);
    const [openExportar, setOpenExportar] = useState(false);
    const [filtroMes, setFiltroMes] = useState("");
    const [filtroAnio, setFiltroAnio] = useState("");
    const [filtroSucursal, setFiltroSucursal] = useState("");
    const [openEditar, setOpenEditar] = useState(false);
    const [openEliminar, setOpenEliminar] = useState(false);
    const [egresoSeleccionado, setEgresoSeleccionado] = useState(null);
    const [nuevoEgreso, setNuevoEgreso] = useState({
        name: "",
        branch_id: "",
        tipo: "",
        descripcion: "",
        fecha_registro: "",
        monto: "",
        estado:''
    });
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [filtroMesResumen, setFiltroMesResumen] = useState("");
const [filtroAnioResumen, setFiltroAnioResumen] = useState("");


    const handleCrearEgreso = async () => {
        setEnviandoAlert(true)
        try {
            await crearEgreso(nuevoEgreso);
            setOpenCrear(false);
            setNuevoEgreso({
                name: "",
                branch_id: "",
                tipo: "",
                descripcion: "",
                fecha_registro: "",
                monto: "",
                estado:''
            });
            setEnviandoAlert(false);
            setSuccessAlertOpen(true);
            setAlertMessage('Se ha creado correctamente el Egreso')
            refetchEgresos();
        } catch (error) {
            setEnviandoAlert(false);
            setErrorAlertOpen(true);
            setAlertMessage("Error al crear egreso:", error)
        }
    };

    const nombresMeses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];


    // 🔹 Extraer meses únicos

    const mesesUnicos = Array.from(
        new Set(
            egresos.map((e) => {
                const fecha = new Date(e.fecha_registro);
                return fecha.getUTCMonth(); // evita desfase de zona horaria
            })
        )
    ).sort((a, b) => a - b);

    // Años únicos
    const aniosUnicos = Array.from(
        new Set(
            egresos.map((e) => {
                const fecha = new Date(e.fecha_registro);
                return fecha.getUTCFullYear();
            })
        )
    ).sort((a, b) => a - b);



    // 🔍 Filtrado por mes/año
    const egresosFiltrados = egresos.filter((e) => {
        const fecha = new Date(e.fecha_registro);
        const mes = (fecha.getUTCMonth() + 1).toString();
        const anio = fecha.getUTCFullYear().toString();
        const branch = e.branch_id?.toString();

        return (
            (!filtroMes || mes === filtroMes) &&
            (!filtroAnio || anio === filtroAnio) &&
            (!filtroSucursal || branch === filtroSucursal)
        );
    });



    const columns = [
        {
            field: "branch_name",
            headerName: "Sucursal",
            flex: 1,
            
        },

        { field: "tipo", headerName: "Tipo", flex: 1 },
        {
      field: "estado",
      headerName: "Estado",
      width: 180,
      renderCell: (params) => {
        let color = "#ccc"; // default gris

        switch (params.value) {
          case
            "REGISTRADO":
            color = "#daba2c";
            break;
          case
            "PENDIENTE":
            color = "#f0ad4e";
            break;
          case
            "PAGADO":
            color = "#5cb85c";
            break;
          case
            "ANULADO":
            color = "#d98d4f";
            break;
          case "NO PAGO":
            color = "#d9534f";
            break;
          case
            "PROCESO":
            color = "#d7d94f";
            break;
          default:
            color = "#ccc";
        }

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {/* Cuadrado de color */}
            <Box
              sx={{
                width: 100,
                textAlign: 'center',

                color: '#fff',
                borderRadius: 1,
                backgroundColor: color,
              }}
            >
              <span>{params.value}</span>
            </Box>
          </Box>
        );
      },
    },
        { field: "descripcion", headerName: "Descripción", flex: 2 },
        {
            field: "fecha_registro",
            headerName: "Fecha",
            flex: 1,
            renderCell: (params) => {
                const fecha = new Date(params.row.fecha_registro);
                const dia = fecha.getUTCDate();
                const mes = fecha.getUTCMonth() + 1;
                const anio = fecha.getUTCFullYear();
                return `${dia.toString().padStart(2, '0')}-${mes.toString().padStart(2, '0')}-${anio}`;
            }
        },

        {
            field: "monto", headerName: "Monto ($)", flex: 1, renderCell: (params) =>
                new Intl.NumberFormat("es-CL", {
                    style: "currency",
                    currency: "CLP",
                    minimumFractionDigits: 0,
                }).format(params.row.monto || 0),
        },
        {
            field: "acciones",
            headerName: "Acciones",
            flex: 1,
            renderCell: (params) => (
                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        width: 150,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <button
                        className="edit-button"
                        onClick={() => handleOpenEditar(params.row)}
                    >
                        <svg className="edit-svgIcon" viewBox="0 0 512 512">
                            <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                        </svg>
                    </button>
                    <button
                        className="delete-button"
                        onClick={() => handleOpenEliminar(params.row)}
                    >
                        <FaTrashCan className="delete-svgIcon" />
                    </button>
                </Box>
            ),
        }
    ];


// 1️⃣ Detectar el último mes y año ingresado
const ultimoIngreso = egresos.reduce((prev, curr) => {
  const fechaPrev = new Date(prev.fecha_registro);
  const fechaCurr = new Date(curr.fecha_registro);
  return fechaCurr > fechaPrev ? curr : prev;
}, egresos[0] || null);

const mesUltimo = ultimoIngreso ? new Date(ultimoIngreso.fecha_registro).getUTCMonth() : null;
const anioUltimo = ultimoIngreso ? new Date(ultimoIngreso.fecha_registro).getUTCFullYear() : null;


// 2️⃣ Filtrar ingresos solo para ese mes
const ingresosUltimoMes = egresos.filter((e) => {
  const fecha = new Date(e.fecha_registro);
  return fecha.getUTCMonth() === mesUltimo && fecha.getUTCFullYear() === anioUltimo;
});

// 3️⃣ Calcular total general del mes
const totalUltimoMes = ingresosUltimoMes.reduce((sum, e) => sum + parseFloat(e.monto || 0), 0);


// 4️⃣ Totales por sucursal
const totalesPorSucursalUltimoMes = sucursales
  .map((sucursal) => {
    const totalSucursal = ingresosUltimoMes
      .filter((e) => e.branch_id?.toString() === sucursal.id.toString())
      .reduce((sum, e) => sum + parseFloat(e.monto || 0), 0);
    return { ...sucursal, total: totalSucursal };
  })
  .filter((s) => s.total > 0);


    // Abrir modal editar
    const handleOpenEditar = (egreso) => {
        setEgresoSeleccionado(egreso);
        setNuevoEgreso({
            tipo: egreso.tipo,
            descripcion: egreso.descripcion,
            fecha_registro: egreso.fecha_registro.split("T")[0], // formato yyyy-mm-dd
            monto: egreso.monto,
            estado:egreso.estado
        });
        setOpenEditar(true);
    };

    // Guardar cambios
    const handleEditarEgreso = async () => {
        setEnviandoAlert(true)
        try {
            await editarEgreso(egresoSeleccionado.id, nuevoEgreso);
            setOpenEditar(false);
            setEgresoSeleccionado(null);
            setEnviandoAlert(false);
            setSuccessAlertOpen(true);
            setAlertMessage('Se ha editado correctamente el Egreso')
            refetchEgresos();
            setNuevoEgreso({
                branch_id: "",
                tipo: "",
                descripcion: "",
                fecha_registro: "",
                monto: "",
                estado:''
            });
        } catch (error) {
            setEnviandoAlert(false);
            setErrorAlertOpen(true);
            setAlertMessage("Error al editar egreso:", error)
        }
    };

    // Abrir modal eliminar
    const handleOpenEliminar = (egreso) => {
        setEgresoSeleccionado(egreso);
        setOpenEliminar(true);
    };

    // Confirmar eliminación
    const handleEliminarEgreso = async () => {
        setEnviandoAlert(true)
        try {
            await eliminarEgreso(egresoSeleccionado.id);
            setOpenEliminar(false);
            setEgresoSeleccionado(null);
            setEnviandoAlert(false);
            setSuccessAlertOpen(true);
            setAlertMessage('Se ha eliminado correctamente el Egreso')
            refetchEgresos();
        } catch (error) {
            setEnviandoAlert(false);
            setErrorAlertOpen(true);
            setAlertMessage("Error al eliminar egreso:", error)
        }
    };





const resumenPorMes = useMemo(() => {
    const grupos = {};


    egresos.forEach((e) => {
        const fecha = new Date(e.fecha_registro);
        const mes = fecha.getUTCMonth() + 1;
        const anio = fecha.getUTCFullYear();
        const key = `${anio}-${mes}`;

        if (!grupos[key]) {
            grupos[key] = {
                id: key,
                mes,
                anio,
                nombreMes: nombresMeses[mes - 1],
                totalMes: 0,
                sucursales: {}
            };
        }

        const monto = Number(e.monto || 0);

        grupos[key].totalMes += monto;

        if (!grupos[key].sucursales[e.branch_id]) {
            grupos[key].sucursales[e.branch_id] = 0;
        }
        grupos[key].sucursales[e.branch_id] += monto;

       
    });

   

    return Object.values(grupos).sort(
        (a, b) => new Date(`${b.anio}-${b.mes}-01`) - new Date(`${a.anio}-${a.mes}-01`)
    );
}, [egresos]);


//


// 1) Crear filas preparadas para el DataGrid
const rowsPorMes = resumenPorMes.map((m) => {
    const row = {
        id: m.id,
        mes: `${m.nombreMes} ${m.anio}`,
        totalMes: m.totalMes,
    };

    // convertir sucursales → columnas directas
    sucursales.forEach(s => {
        row[`sucursal_${s.id}`] = m.sucursales[s.id] ?? 0;
    });

    return row;
});

// 2) Columnas base (mes + total)
const columnasBase = [
  { field: "mes", headerName: "Mes", flex: 1 },
  {
    field: "totalMes",
    headerName: "Total Mes",
    flex: 1,
    renderCell: (params) =>
      new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 })
        .format(params.value || 0),
  },
];


// 3) Columnas dinámicas por sucursal (seguras)
const columnasSucursales = sucursales
  .map((s) => {
    // 🔥 verificar si esta sucursal tiene al menos un valor > 0
    const tieneMovimiento = rowsPorMes.some(
      (row) => (row[`sucursal_${s.id}`] || 0) > 0
    );

    if (!tieneMovimiento) return null; // ❌ no mostrar columna

    return {
      field: `sucursal_${s.id}`,
      headerName: s.name,
      flex: 1,
      renderCell: (params) =>
        new Intl.NumberFormat("es-CL", {
          style: "currency",
          currency: "CLP",
          minimumFractionDigits: 0,
        }).format(params.value || 0),
    };
  })
  .filter(Boolean); // 🔥 elimina null



const columnasCompletas = [...columnasBase, ...columnasSucursales];



const mesesDisponibles = Array.from(
  new Set(rowsPorMes.map(r => r.mes.split(" ")[0]))
);

const aniosDisponibles = Array.from(
  new Set(rowsPorMes.map(r => r.anio || r.mes.split(" ")[1]))
);


const rowsFiltradas = rowsPorMes.filter((r) => {
  const [nombreMes, anio] = r.mes.split(" ");

  return (
    (!filtroMesResumen || nombreMes === filtroMesResumen) &&
    (!filtroAnioResumen || anio === filtroAnioResumen)
  );
});



    return (
        <Container maxWidth="xl">
            <Paper
                elevation={3}
                sx={{
                    p: 3,
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    minHeight: "70vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* 🔹 Título */}
                <Box display="flex" alignItems="center" gap={2} mb={4}>
                    <img
                        src={Logocolor}
                        alt="Logo Clínica Activa"
                        style={{ width: 55, height: 55, objectFit: "contain" }}
                    />
                    <Typography variant="h5" sx={TituloPrincipal}>
                        Egresos CBO
                    </Typography>
                </Box>
                <Box mb={5}>
                    <Card
                        sx={{
                            width: '50%',
                            backgroundColor: "#ffffff",
                            borderRadius: 3,
                            boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                            transition: "transform 0.2s, box-shadow 0.2s",
                        }}
                    >
                        <CardContent
                            gap={1}
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                sx={{
                                    width: "80%",
                                    flexDirection: "column",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                }}
                                gap={1}
                                mb={1}
                            >
                                <Typography
                                    variant="h4"
                                    fontWeight={400}
                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                >
                                      {new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", minimumFractionDigits: 0 }).format(totalUltimoMes)}
                                </Typography>
                                <Typography
                                    variant="h6"
                                    fontWeight={500}
                                    sx={{ fontFamily: "Poppins", color: "#585857" }}
                                >
                                    Total{" "}
                                    <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                        Monto Mes {mesUltimo !== null ? `${nombresMeses[mesUltimo]} ${anioUltimo}` : ""}
                                    </Box>
                                </Typography>
                            </Box>

                            <Box>
                                <GiMoneyStack size={60} color="#5cd09aff" />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
                {/* 🔹 Totales por sucursal */}
<Box mb={4}>
  <Typography
    variant="h6"
    fontWeight={600}
   sx={{
      fontFamily: "Poppins",
      color: "#274a41ff",
      mb: 2,
      fontSize:'1rem'
      
    }}
  >
    Egresos por Sucursal {mesUltimo !== null ? `${nombresMeses[mesUltimo]} ${anioUltimo}` : ""}
  </Typography>

  <Grid container spacing={2} mb={4}>
    {totalesPorSucursalUltimoMes.length > 0 ? (
      totalesPorSucursalUltimoMes.map((sucursal) => (
        <Grid size={{xs:12, sm:6, md:3}} key={sucursal.id}>
          <Card
            sx={{
              backgroundColor: "#f9f9f9",
              borderRadius: 3,
              boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
              p: 2,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              transition: "transform 0.2s ease",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0px 6px 12px rgba(0,0,0,0.15)",
              },
            }}
          >
            <CardContent
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  variant="subtitle1"
                  sx={{ fontFamily: "Poppins", color: "#585857" }}
                >
                  {sucursal.name}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    color: "#2a8d74",
                  }}
                >
                  {new Intl.NumberFormat("es-CL", {
                    style: "currency",
                    currency: "CLP",
                    minimumFractionDigits: 0,
                  }).format(sucursal.total)}
                </Typography>
              </Box>
              <GiMoneyStack size={40} color="#2a8d74" />
            </CardContent>
          </Card>
        </Grid>
      ))
    ) : (
      <Typography
        variant="body1"
        sx={{
          fontFamily: "Poppins",
          color: "#888",
          mt: 2,
          textAlign: "center",
          width: "100%",
        }}
      >
        No hay egresos registrados este mes.
      </Typography>
    )}
  </Grid>
</Box>


                {/* 🔹 Filtros */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>

                    <Box display="flex" gap={2}>
                        {/* Select Mes */}
                        {/* Select Mes */}
                        <FormControl
                            size="small"
                            sx={{
                                ...InputBuscador,
                                minWidth: 200,
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "50px",
                                },
                            }}
                        >
                            <InputLabel>Mes</InputLabel>
                            <Select
                                label="Mes"
                                value={filtroMes}
                                onChange={(e) => setFiltroMes(e.target.value)}
                                IconComponent={() => null}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <SearchIcon sx={{ color: "#2a8d74" }} />
                                    </InputAdornment>
                                }
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {mesesUnicos.map((mes) => (
                                    <MenuItem key={mes} value={(mes + 1).toString()}>
                                        {nombresMeses[mes]}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* Select Año */}
                        <FormControl
                            size="small"
                            sx={{
                                ...InputBuscador,
                                minWidth: 200,
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "50px",
                                },
                            }}
                        >
                            <InputLabel>Año</InputLabel>
                            <Select
                                label="Año"
                                value={filtroAnio}
                                onChange={(e) => setFiltroAnio(e.target.value)}
                                IconComponent={() => null}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <SearchIcon sx={{ color: "#2a8d74" }} />
                                    </InputAdornment>
                                }
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {aniosUnicos.map((anio) => (
                                    <MenuItem key={anio} value={anio.toString()}>
                                        {anio}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl size="small" sx={{ ...InputBuscador, minWidth: 180 }}>
                            <InputLabel>Sucursal</InputLabel>
                            <Select
                                label="Sucursal"
                                value={filtroSucursal}
                                onChange={(e) => setFiltroSucursal(e.target.value)}
                            >
                                <MenuItem value="">Todas</MenuItem>
                                {sucursales?.map((s) => (
                                    <MenuItem key={s.id} value={s.id.toString()}>
                                        {s.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* Botón buscar */}
                        <IconButton
                            onClick={refetchEgresos}
                            sx={{
                                backgroundColor: "#2a8d74",
                                color: "white",
                                "&:hover": { backgroundColor: "#236f5c" },
                            }}
                        >
                            <SearchIcon />
                        </IconButton>
                    </Box>


                    {/* 🔹 Botones */}
                    <Box display="flex" gap={2}>
                        <Button
                            startIcon={<AddCircleOutlineIcon />}
                            variant="contained"
                            sx={{
                                backgroundColor: "#2a8d74",
                                borderRadius: "50px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                            }}
                            onClick={() => setOpenCrear(true)}
                        >
                            Nuevo Egreso CBO
                        </Button>

                        <Button
                            startIcon={<DownloadIcon />}
                            variant="outlined"
                            sx={{
                                borderColor: "#2a8d74",
                                color: "#2a8d74",
                                borderRadius: "50px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                            }}
                            onClick={() => setOpenExportar(true)}
                        >
                            Exportar Excel
                        </Button>
                    </Box>
                </Box>

                {/* 🔹 Tabla o mensaje */}
                {loadingEgresos ? (
                    <Box display="flex" justifyContent="center" mt={6}>
                        <CircularProgress />
                    </Box>
                ) : egresosFiltrados.length === 0 ? (
                    <Box textAlign="center" mt={8}>
                        <ErrorOutlineIcon sx={{ fontSize: 50, color: "#999" }} />
                        <Typography sx={{ fontFamily: "Poppins", color: "#777", mt: 1 }}>
                            No hay egresos creados
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ height: 450, width: "100%" }}>
                        <DataGrid
                            rows={egresosFiltrados}
                            columns={columns}
                            getRowId={(row) => row.id}
                            disableRowSelectionOnClick
                            pageSize={5}
                            slots={{ noRowsOverlay: DiseñoDataGrid }}
                            sx={{
                                fontFamily: 'Poppins, sans-serif',
                                '& .MuiDataGrid-columnHeaders': {
                                    color: '#113e21ff',
                                    fontWeight: 600,
                                    textTransform: 'capitalize',
                                },
                                '& .MuiDataGrid-cell': {
                                    textTransform: 'capitalize',
                                },
                            }}
                        />
                    </Box>
                )}

                <Box mt={5}>
    <Typography
            variant="h6"
            fontWeight={600}
            sx={{ fontFamily: "Poppins", color: "#113e21ff", mb: 2 }}
          >
        Resumen por Mes y Sucursal de Egresos
    </Typography>

    <Box display="flex" gap={2} mb={2}>
  <FormControl size="small" sx={{...InputBuscador, minWidth: 150 }}>
    <InputLabel>Mes</InputLabel>
    <Select
      value={filtroMesResumen}
      label="Mes"
      onChange={(e) => setFiltroMesResumen(e.target.value)}
    >
      <MenuItem value="">Todos</MenuItem>
      {mesesDisponibles.map((mes) => (
        <MenuItem key={mes} value={mes}>{mes}</MenuItem>
      ))}
    </Select>
  </FormControl>

  <FormControl size="small" sx={{ ...InputBuscador, minWidth: 150 }}>
    <InputLabel>Año</InputLabel>
    <Select
      value={filtroAnioResumen}
      label="Año"
      onChange={(e) => setFiltroAnioResumen(e.target.value)}
    >
      <MenuItem value="">Todos</MenuItem>
      {aniosDisponibles.map((año) => (
        <MenuItem key={año} value={año}>{año}</MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>


    <Box sx={{ height: 480, width: "100%" }}>
     <DataGrid
  rows={rowsFiltradas}
  columns={columnasCompletas}
  getRowId={(row) => row.id}
  autoHeight
  pageSize={10}
  disableSelectionOnClick
/>

    </Box>
</Box>

            </Paper>

            {/* 🟢 Dialog Crear */}
            <Dialog open={openCrear} onClose={() => setOpenCrear(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={Texto}>Nuevo Egreso CBO</DialogTitle>
                <DialogContent dividers>
                    <Box display="flex" flexDirection="column" gap={2}>

                        <FormControl fullWidth sx={Input}>
                            <InputLabel>Tipo</InputLabel>
                            <Select
                                value={nuevoEgreso.tipo}
                                label="Tipo"
                                onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, tipo: e.target.value })}
                            >
                                <MenuItem value="Remuneración CBO">Remuneración CBO</MenuItem>
                                <MenuItem value="Insumos">Insumos</MenuItem>
                                <MenuItem value="Agua">Agua</MenuItem>
                                <MenuItem value="Telefonía">Telefonía</MenuItem>
                                <MenuItem value="Gastos Generales">Gastos Generales</MenuItem>
                                <MenuItem value="Gastos administrativos">Gastos administrativos</MenuItem>
                                <MenuItem value="Vigilancia">Vigilancia</MenuItem>
                                <MenuItem value="Combustibles y lubricantes">Combustibles y lubricantes</MenuItem>
                                <MenuItem value="Luz">Luz</MenuItem>
                                <MenuItem value="Aseo">Aseo</MenuItem>
                                <MenuItem value="Iva No recuperable">Iva No recuperable</MenuItem>
                                <MenuItem value="Otros">Otros</MenuItem>
                                <MenuItem value="Depreciación">Depreciación</MenuItem>
                                <MenuItem value="Gasto retroactivo">Gasto retroactivo</MenuItem>
                                <MenuItem value="Pago pendiente">Pago pendiente</MenuItem>
                                <MenuItem value="Regularización">Regularización</MenuItem>
                                <MenuItem value="Egreso atrasado">Egreso atrasado</MenuItem>
                                  <MenuItem value="Participación CBO">Participación CBO</MenuItem>

                            </Select>
                        </FormControl>

                        <FormControl fullWidth sx={Input}>
                            <InputLabel>Sucursal</InputLabel>
                            <Select
                                value={nuevoEgreso.branch_id}
                                label="Sucursal"
                                onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, branch_id: Number(e.target.value) })}
                            >
                                {sucursales?.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {s.name} {/* ajusta según el campo de tu sucursal */}
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                                <TextField
                                                select
                                                fullWidth
                                                label="Estado ingreso"
                                                name="estado"
                                                sx={Input}
                                                value={nuevoEgreso.estado}
                                                onChange={(e) =>setNuevoEgreso({ ...nuevoEgreso, estado: e.target.value })}
                                                margin="normal"
                                            >
                                                      <MenuItem value="REGISTRADO">registrado</MenuItem>
                                                   <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                                                     <MenuItem value="PROCESO">Proceso</MenuItem>
                                                    <MenuItem value="NO PAGO">No pagado</MenuItem>
                          <MenuItem value="PAGADO">Pagado</MenuItem>
                          <MenuItem value="ANULADO">Anulado</MenuItem>
                                               
                                            </TextField>

                        <TextField
                            label="Fecha de registro"
                            type="date"
                            value={nuevoEgreso.fecha_registro}
                            onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, fecha_registro: e.target.value })}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={inputFechaGrande}
                             InputProps={{
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                    <CalendarToday />
                                                  </InputAdornment>
                                                ),
                                              }}
                        />
                        <TextField
                            label="Monto"
                            type="number"
                            value={nuevoEgreso.monto}
                            onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, monto: e.target.value })}
                            fullWidth
                            sx={Input}
                        />
                        <TextField
                            label="Descripción"
                            value={nuevoEgreso.descripcion}
                            onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, descripcion: e.target.value })}
                            fullWidth
                            multiline
                            rows={2}
                            sx={InputDescripcion}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={buttonCancelar} onClick={() => setOpenCrear(false)}>
                        Cancelar
                    </Button>
                    <Button sx={buttonGuardar} onClick={handleCrearEgreso}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog open={openEliminar} onClose={() => setOpenEliminar(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={TituloPrincipal}>Confirmar eliminación</DialogTitle>
                <DialogContent dividers>
                    <Typography sx={Texto}>¿Estás seguro que deseas eliminar este egreso?</Typography>
                    <Typography fontWeight={500} sx={Texto} mt={1}>{egresoSeleccionado?.tipo}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button sx={buttonCancelar} onClick={() => setOpenEliminar(false)}>Cancelar</Button>
                    <Button sx={buttonGuardar} onClick={handleEliminarEgreso}>Eliminar</Button>
                </DialogActions>
            </Dialog>


            {/* 🟣 Dialog Exportar */}
            <Dialog open={openExportar} onClose={() => setOpenExportar(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Exportar Egresos a Excel</DialogTitle>
                <DialogContent dividers>
                    <Box display="flex" flexDirection="column" gap={2}>
                        {/* Select Sucursal */}
                        <FormControl
                            fullWidth
                            sx={{
                                ...InputBuscador,
                                minWidth: 200,
                                "& .MuiOutlinedInput-root": { borderRadius: "50px" },
                            }}
                        >
                            <InputLabel>Sucursal</InputLabel>
                            <Select
                                label="Sucursal"
                                value={filtroSucursal?.toString() || ""}
                               onChange={(e) => setFiltroSucursal(e.target.value.toString())}
                            >
                                <MenuItem value="">Todas</MenuItem>
                                {sucursales.map((s) => (
    <MenuItem key={s.id} value={s.id.toString()}>
        {s.name}
    </MenuItem>
))}
                            </Select>
                        </FormControl>

                        {/* Select Mes */}
                        <FormControl
                            fullWidth
                            sx={{
                                ...InputBuscador,
                                minWidth: 200,
                                "& .MuiOutlinedInput-root": { borderRadius: "50px" },
                            }}
                        >
                            <InputLabel>Mes</InputLabel>
                            <Select
                                label="Mes"
                                value={filtroMes}
                                onChange={(e) => setFiltroMes(e.target.value)}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {mesesUnicos.map((mes) => (
                                    <MenuItem key={mes} value={(mes + 1).toString()}>
                                        {nombresMeses[mes]}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        {/* Select Año */}
                        <FormControl
                            fullWidth
                            sx={{
                                ...InputBuscador,
                                minWidth: 200,
                                "& .MuiOutlinedInput-root": { borderRadius: "50px" },
                            }}
                        >
                            <InputLabel>Año</InputLabel>
                            <Select
                                label="Año"
                                value={filtroAnio}
                                onChange={(e) => setFiltroAnio(e.target.value)}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {aniosUnicos.map((anio) => (
                                    <MenuItem key={anio} value={anio.toString()}>
                                        {anio}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button sx={buttonCancelar} onClick={() => setOpenExportar(false)}>
                        Cancelar
                    </Button>
                    <Button
                        sx={buttonGuardar}
                        onClick={() => {
                            handleExportarExcel(egresos, filtroMes, filtroAnio, filtroSucursal, sucursales);
                            setOpenExportar(false);
                        }}
                    >
                        Exportar
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog open={openEditar} onClose={() => setOpenEditar(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Editar Egreso</DialogTitle>
                <DialogContent dividers>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <TextField
                            label="Tipo"
                            value={nuevoEgreso.tipo}
                            onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, tipo: e.target.value })}
                            fullWidth
                            sx={Input}
                        />

                        <FormControl fullWidth sx={Input}>
                            <InputLabel>Sucursal</InputLabel>
                            <Select
                                value={nuevoEgreso.branch_id}
                                label="Sucursal"
                                onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, branch_id: Number(e.target.value) })}
                            >
                                {sucursales?.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>
                                        {s.name} {/* ajusta según el campo de tu sucursal */}
                                    </MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                                  <TextField
                                                select
                                                fullWidth
                                                label="Estado ingreso"
                                                name="estado"
                                                sx={Input}
                                                value={nuevoEgreso.estado}
                                                onChange={(e) =>setNuevoEgreso({ ...nuevoEgreso, estado: e.target.value })}
                                                margin="normal"
                                            >
                                                      <MenuItem value="REGISTRADO">registrado</MenuItem>
                                                   <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                                                     <MenuItem value="PROCESO">Proceso</MenuItem>
                                                    <MenuItem value="NO PAGO">No pagado</MenuItem>
                          <MenuItem value="PAGADO">Pagado</MenuItem>
                          <MenuItem value="ANULADO">Anulado</MenuItem>
                                               
                                            </TextField>
                        <TextField
                            label="Descripción"
                            value={nuevoEgreso.descripcion}
                            onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, descripcion: e.target.value })}
                            fullWidth
                            multiline
                            rows={2}
                            sx={InputDescripcion}
                        />
                        <TextField
                            label="Fecha de registro"
                            type="date"
                            value={nuevoEgreso.fecha_registro}
                            onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, fecha_registro: e.target.value })}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={inputFechaGrande}
                        />
                        <TextField
                            label="Monto"
                            type="number"
                            value={nuevoEgreso.monto}
                            onChange={(e) => setNuevoEgreso({ ...nuevoEgreso, monto: e.target.value })}
                            fullWidth
                            sx={Input}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={buttonCancelar} onClick={() => setOpenEditar(false)}>Cancelar</Button>
                    <Button sx={buttonGuardar} onClick={handleEditarEgreso}>Guardar</Button>
                </DialogActions>
            </Dialog>


            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert}>
                <Box sx={modalStyle}>
                    <section style={{ textAlign: "center", padding: "1rem" }}>
                        <CircularProgress style={{ color: "#2a8d74" }} />
                        <p className="alert-text">Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
        </Container>
    );
};
